import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { getWindowDimensions } from "../utils";
import { useEffect } from "react";

const FALLBACK_IMAGE =
  "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/product-placeholder.svg";

const SLIDES = [
  {
    id: 1,
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/heroBanner.jpeg",
    title: "Wear the Feeling",
    subtitle:
      "Designed for children who feel deeply. <br /> Crafted with love for parents who notice.",
    buttonText: "Explore Shop",
    buttonLink: "/shop",
  },
  {
    id: 6,
    title: "Little Wanderers",
    subtitle:
      "A world of tiny explorers. Storybook adventurers for curious little hearts.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/6/ChatGPTImageMay16202601_43_20P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/little-wanderers",
  },
  {
    id: 4,
    title: "Tiny Tropics",
    subtitle: "Beach days. Sunny ways. Tiny adventures.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/4/ChatGPTImageMay16202601_14_58P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/tiny-tropics",
  },
  {
    id: 5,
    title: "Adventure Trails",
    subtitle: "Little feet. Big adventures. Memories that last forever.",
    image:
      "https://huehoppers.s3.amazonaws.com/uploads/collection/banner_image/5/ChatGPTImageMay16202601_07_30P.jpeg",
    buttonText: "Shop Collection",
    buttonLink: "/collections/adventure-trails",
  },
  // {
  //   image:
  //     "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/heroBanner.jpeg",
  //   title: "Wear the Feeling",
  //   subtitle:
  //     "Designed for children who feel deeply. <br /> Crafted with love for parents who notice.",
  //   buttonText: "Shop Collection",
  //   buttonLink: "/shop?gender=female&product_type=TShirt&age=non_infant",
  // },
];

const BOTTOM_SLIDES = [
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/mid-age-girl-child2.png",
    title: "Expressing Mood. <br />Unfiltered.",
    buttonText: "Explore Shop",
    buttonLink: "/shop",
  },
];

const HomeV2 = () => {
  useEffect(() => {
    document.title = "Home | HueHoppers – Joyful Kids' Fashion";
  }, []);
  return (
    <>
      <style>{`
        @media (min-width: 1368px) {
          .half-img-box {
            width: 50%;
          }
          .collection-image {
            height: auto !important;
          }
        }
        @media (max-width: 1368px) {
          .half-img-box {
            width: 100%;
          }
            .collection-image {
              height: 100% !important;
            }
        }
          
      `}</style>
      <div className="px-0">
        <div
          className="tf-slideshow slider-home-2 slider-effect-fade position-relative"
          style={{ border: "2px solid white" }}
        >
          <Swiper
            modules={[Autoplay, Pagination, EffectFade]}
            effect="fade"
            loop={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            speed={1000}
            pagination={{
              clickable: true,
              el: ".sw-pagination-slider",
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
            }}
            slidesPerView={1}
            className="tf-sw-slideshow"
          >
            {SLIDES.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="wrap-slider" style={{ height: "100vh" }}>
                  <img
                    loading="lazy"
                    decoding="async"
                    src={slide.image}
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt={`banner-${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100vh",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                  <div className="box-content">
                    <div className="container">
                      <h1 className="fade-item fade-item-1  text_white">
                        {slide.title.split(" for ").map((part, i) => (
                          <span key={i}>{part}</span>
                        ))}
                      </h1>
                      <p
                        className="fade-item fade-item-2 text_white"
                        dangerouslySetInnerHTML={{ __html: slide.subtitle }}
                        style={{ display: "block" }}
                      />
                      <div className="fade-item fade-item-3">
                        <Link
                          style={{
                            backgroundColor: "white",
                          }}
                          to={slide.buttonLink}
                          className="tf-btn btn-outline-light btn-xl radius-4"
                        >
                          <span style={{ color: "black" }}>
                            {slide.buttonText}
                          </span>
                          <i
                            style={{ color: "black" }}
                            className="icon icon-arrow-right"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="wrap-pagination">
              <div className="container">
                <div className="sw-dots line-pagination sw-pagination-slider swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                  <span
                    className="swiper-pagination-bullet"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 1"
                  />
                  <span
                    className="swiper-pagination-bullet"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 2"
                  />
                  <span
                    className="swiper-pagination-bullet swiper-pagination-bullet-active"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 3"
                    aria-current="true"
                  />
                </div>
              </div>
            </div>
          </Swiper>

          {/* Pagination dots */}
        </div>
      </div>
      <div className="px-0">
        <div
          className=" py-0"
          style={{
            border: "2px solid white",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className="half-img-box">
            <div className="collection-item-v4 style-2 hover-img">
              <div className="collection-inner">
                <a
                  href="/shop?product_type=Romper"
                  className="collection-image img-style radius-0 o-hidden"
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className=" lazyloaded"
                    data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/romper.png"
                    src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/romper.png"
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt="collection-img"
                    style={{
                      height:
                        getWindowDimensions().width >= 1368 ? "100vh" : "100%",
                      width: "100%",
                      border: "2px solid white",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                </a>
                <div
                  className="collection-content wow fadeInUp"
                  data-wow-delay="0s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0s",
                    animationName: "fadeInUp",
                  }}
                >
                  <h5 className="heading  fs-52 text-white">
                    The First Feeling
                  </h5>
                  <p
                    className="fade-item fade-item-2 text_white"
                    dangerouslySetInnerHTML={{
                      __html:
                        "For the ones just beginning to discover the world.",
                    }}
                    style={{ display: "block" }}
                  />
                  <a
                    style={{
                      backgroundColor: "white",
                    }}
                    href="/shop?product_type=Romper"
                    className="tf-btn btn-outline-light radius-4"
                  >
                    <span style={{ marginRight: 10, color: "black" }}>
                      Shop Rompers
                    </span>
                    <i
                      style={{ color: "black" }}
                      className="icon icon-arrow-right"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="half-img-box">
            <div className="collection-item-v4 style-2 hover-img">
              <div className="collection-inner">
                <a
                  href="/shop?product_type=TShirt"
                  className="collection-image img-style radius-0 o-hidden"
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className=" lazyloaded"
                    data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/boy-tee.jpeg"
                    src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/boy-tee.jpeg"
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt="collection-img"
                    style={{
                      height:
                        getWindowDimensions().width >= 1368 ? "100vh" : "100%",
                      width: "100%",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                </a>
                <div
                  className="collection-content wow fadeInUp"
                  data-wow-delay="0s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0s",
                    animationName: "fadeInUp",
                  }}
                >
                  <h5 className="heading  fs-52 text-white">
                    The Everyday Tee
                  </h5>
                  <p
                    className="fade-item fade-item-2 text_white"
                    dangerouslySetInnerHTML={{
                      __html: "For the child who carries a whole world inside.",
                    }}
                    style={{ display: "block" }}
                  />
                  <a
                    style={{
                      backgroundColor: "white",
                    }}
                    href="/shop?product_type=TShirt"
                    className="tf-btn btn-outline-light radius-4"
                  >
                    <span style={{ marginRight: 10, color: "black" }}>
                      Shop Tees
                    </span>
                    <i
                      style={{ color: "black" }}
                      className="icon icon-arrow-right"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-0">
        <div
          className="tf-slideshow slider-home-2 slider-effect-fade position-relative"
          style={{ border: "2px solid white" }}
        >
          <Swiper
            modules={[Autoplay, Pagination, EffectFade]}
            effect="fade"
            loop={true}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            speed={1000}
            pagination={{
              clickable: true,
              el: ".sw-pagination-slider",
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
            }}
            slidesPerView={1}
            className="tf-sw-slideshow"
          >
            {BOTTOM_SLIDES.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="wrap-slider" style={{ height: "100vh" }}>
                  <img
                    loading="lazy"
                    decoding="async"
                    src={slide.image}
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt={`banner-${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                  <div className="box-content">
                    <div className="container">
                      <h1
                        className="fade-item fade-item-1  text_white"
                        dangerouslySetInnerHTML={{ __html: slide.title }}
                      />

                      <p
                        className="fade-item fade-item-2 text_white"
                        dangerouslySetInnerHTML={{ __html: slide.subtitle }}
                        style={{ display: "block" }}
                      />
                      <div className="fade-item fade-item-3">
                        <Link
                          style={{
                            backgroundColor: "white",
                          }}
                          to={slide.buttonLink}
                          className="tf-btn btn-outline-light btn-xl radius-4"
                        >
                          <span style={{ color: "black" }}>
                            {slide.buttonText}
                          </span>
                          <i
                            style={{ color: "black" }}
                            className="icon icon-arrow-right"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Pagination dots */}
          <div className="wrap-pagination sw-absolute-2">
            <div className="container">
              <div className="sw-dots dots-fill-white justify-content-center sw-pagination-slider swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" />
            </div>
          </div>
        </div>
      </div>
      <div className="px-0">
        <div
          className=" py-0"
          style={{
            border: "2px solid white",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className="half-img-box">
            <div className="collection-item-v4 style-2 hover-img">
              <div className="collection-inner">
                <a
                  href="/collections/sun-shenanigans"
                  className="collection-image img-style radius-0 o-hidden"
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className=" lazyloaded"
                    data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/collection2.png"
                    src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/collection2.png"
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt="collection-img"
                    style={{
                      height:
                        getWindowDimensions().width >= 1368 ? "100vh" : "100%",
                      width: "100%",
                      border: "2px solid white",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                </a>
                <div
                  className="collection-content wow fadeInUp"
                  data-wow-delay="0s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0s",
                    animationName: "fadeInUp",
                  }}
                >
                  <h5 className="heading  fs-52 text-white">
                    Sun & Shenanigans
                  </h5>
                  <p
                    className="fade-item fade-item-2 text_white"
                    dangerouslySetInnerHTML={{
                      __html:
                        "For the ones just beginning to discover the world.",
                    }}
                    style={{ display: "block" }}
                  />
                  <a
                    style={{
                      backgroundColor: "white",
                    }}
                    href="/collections/sun-shenanigans"
                    className="tf-btn btn-outline-light radius-4"
                  >
                    <span style={{ marginRight: 10, color: "black" }}>
                      Explore Collection
                    </span>
                    <i
                      style={{ color: "black" }}
                      className="icon icon-arrow-right"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="half-img-box">
            <div className="collection-item-v4 style-2 hover-img">
              <div className="collection-inner">
                <a
                  href="/the-difference"
                  className="collection-image img-style radius-0 o-hidden"
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className="lazyloaded"
                    data-src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/cloth.png"
                    src="https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/home/cloth.png"
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = FALLBACK_IMAGE;
                    }}
                    alt="collection-img"
                    style={{
                      height:
                        getWindowDimensions().width >= 1368 ? "100vh" : "100%",
                      width: "100%",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      zIndex: 0,
                      border: "2px solid white",
                    }}
                  />
                </a>
                <div
                  className="collection-content wow fadeInUp"
                  data-wow-delay="0s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0s",
                    animationName: "fadeInUp",
                  }}
                >
                  <h5 className="heading  fs-52 text-white">
                    The Difference is in the Details
                  </h5>
                  <p
                    className="fade-item fade-item-2 text_white"
                    dangerouslySetInnerHTML={{
                      __html: "Every stitch. Every thread. Every feeling.",
                    }}
                    style={{ display: "block" }}
                  />
                  <a
                    style={{
                      backgroundColor: "white",
                    }}
                    href="/the-difference"
                    className="tf-btn btn-outline-light radius-4"
                  >
                    <span style={{ marginRight: 10, color: "black" }}>
                      Our Story
                    </span>
                    <i
                      style={{ color: "black" }}
                      className="icon icon-arrow-right"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeV2;
